import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  Label,
  CardBody,
  CardTitle,
  Container,
  Button,
  Progress,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import moment from "moment";
import { AvField, AvForm } from "availity-reactstrap-validation";

const COGSProductsDateRangeReport = (props) => {
  const { SearchBar } = Search;
  const [dateRange, setDateRange] = useState({
    from_date: moment().startOf("month").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    loadAllBranches();
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allBranches, setAllBranches] = useState([]);
  const [progress, setProgress] = useState(0);
  const BATCH_SIZE = 10;
  const CONCURRENCY = 2;
  const ordersRequestId = useRef(0);

  const loadAllBranches = async () => {
    try {
      let url = process.env.REACT_APP_BASEURL + "stores/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        const res = response.data.filter(
          (store) =>
            store.type !== "EQUIPMENT STORE" && store.is_active === true,
        );
        // const res = response.data.filter((store) => (store.type === "CENTRAL KITCHEN STORE" || store.name === "ABUSAMRA"));
        // const sorted =  res.sort((a, b) => a.name.localeCompare(b.name))
        setAllBranches(res);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoading(true);
      setProgress(0);
      setAllOrders([]);

      const url =
        process.env.REACT_APP_BASEURL + "reports/cogs_products_daily_report";
      const mapBranches = (branches) =>
        (branches || []).map((branch) => ({
          ...branch,
          id: branch.id || branch._id,
        }));

      const branchIds = allBranches.map((branch) => branch._id);
      const batches = [];
      for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
        batches.push(branchIds.slice(i, i + BATCH_SIZE));
      }
      const totalBatches = batches.length || 1;
      let completed = 0;
      let nextIndex = 0;

      const runWorker = async () => {
        while (nextIndex < batches.length) {
          if (requestId !== ordersRequestId.current) return;
          const index = nextIndex++;
          const payload = {
            date_from: dateRange?.from_date,
            date_to: dateRange?.to_date,
            branch_ids: batches[index],
          };
          try {
            const batchResponse = await postSubmitForm(url, payload);
            if (requestId !== ordersRequestId.current) return;
            if (batchResponse && batchResponse.status === 1) {
              const newBranchData = mapBranches(
                batchResponse.data.branches || [],
              );
              setAllOrders((prevOrders) => {
                const newBranchIds = new Set(
                  newBranchData.map((branch) => String(branch._id)),
                );
                const filteredPrevOrders = prevOrders.filter(
                  (order) => !newBranchIds.has(String(order._id)),
                );
                return [...filteredPrevOrders, ...newBranchData];
              });
            }
          } catch (batchError) {
            console.error(`Error processing batch ${index + 1}:`, batchError);
          } finally {
            completed += 1;
            setProgress(Math.round((completed / totalBatches) * 100));
          }
        }
      };

      const workers = Math.min(CONCURRENCY, batches.length || 1);
      await Promise.all(Array.from({ length: workers }, () => runWorker()));
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 400));
        if (requestId === ordersRequestId.current) {
          setIsLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (allBranches.length > 0) {
        setAllOrders([]);
        if (isMounted) {
          // await loadOrders();
        }
      }
    };

    fetchData();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [allBranches]);

  const calculateCOGS = (row) => {
    const cogs =
      Number(row.product_cost_opening ? row.product_cost_opening : 0) +
      Number(row.product_purchase_cost) +
      Number(row.product_inbound_transfer_cost) -
      Number(row.product_outbound_transfer_cost) -
      Number(row.product_cost);

    return isNaN(cogs) ? 0 : cogs;
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Branch"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span className="mr-2">
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Opening"),
      dataField: "product_cost_opening",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      dataField: "product_purchase_cost",
      text: props.t("Purchase"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      dataField: "product_outbound_transfer_cost",
      text: props.t("Out Trans"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      dataField: "product_inbound_transfer_cost",
      text: props.t("In Trans"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      text: props.t("Closing"),
      dataField: "product_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      text: props.t("COGS"),
      dataField: "cogs",
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const cogsA = calculateCOGS(rowA);
        const cogsB = calculateCOGS(rowB);

        if (order === "asc") {
          return cogsA - cogsB;
        }
        return cogsB - cogsA;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        let cogs = calculateCOGS(row);

        if (isNaN(cogs)) {
          cogs = "0.00";
        } else {
          cogs = cogs.toFixed(2);
        }
        return cogs;
      },
    },
    {
      text: props.t("Used"),
      dataField: "used_product_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      text: props.t("Waste"),
      dataField: "waste_product_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      formatter: (cell, row) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    {
      text: props.t("Discard"),
      dataField: "discard_product_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{cell ? cell : "0.00"}</span>;
      },
    },
    // {
    //   dataField: "free_products_cost",
    //   text: props.t("Used Free"),
    //   sort: true,
    //   headerStyle: { width: "5%" },
    //   formatter: (cell, row, rowIndex) => {
    //     return <span>{cell ? cell : "0.00"}</span>;
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "5%" };
    //   },
    // },
  ];

  const handleDownload = async () => {
    const fileName = `cogs_report_products`;
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        let cogs = calculateCOGS(v);
        if (isNaN(cogs)) {
          cogs = "0.00";
        } else {
          cogs = cogs.toFixed(2);
        }
        data.push({
          Branch: v.name,
          "Opening Cost": v.product_cost_opening,
          "Purchase Cost": v.product_purchase_cost,
          "Outbound Transfer": v.product_outbound_transfer_cost,
          "Inbound Transfer": v.product_inbound_transfer_cost,
          "Closing Cost": v.product_cost,
          COGS: cogs,
          Used: v.used_product_cost,
          Waste: v.waste_product_cost,
          Discard: v.discard_product_cost,
          // "Free Cost": v.free_products_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("COGS Products - Date Range")}
            title={props.t("COGS Products")}
            breadcrumbItem={props.t("COGS Products - Date Range")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={2} sm={2}>
                        <AvField
                          name="from_date"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateRange?.from_date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            setDateRange((prev) => ({
                              ...prev,
                              from_date:
                                moment(selectedDate).format("YYYY-MM-DD"),
                              to_date:
                                moment(prev.to_date).isAfter(maxDate) ||
                                moment(prev.to_date).isAfter(currentDate)
                                  ? maxDate > currentDate
                                    ? currentDate
                                    : maxDate
                                  : prev.to_date,
                            }));
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>

                      <Col lg={2} sm={2}>
                        <AvField
                          name="to_date"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateRange?.to_date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateRange((prev) => ({
                              ...prev,
                              to_date:
                                moment(selectedDate).format("YYYY-MM-DD"),
                            }));
                          }}
                          min={dateRange.from_date}
                          max={
                            moment(dateRange.from_date)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateRange.from_date)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>

                      <Col lg={3} sm={3}>
                        <Label></Label>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateRange?.from_date && dateRange?.to_date) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                      <Col lg={5} sm={5} className="text-right mt-4">
                        <Button
                          type="submit"
                          className="btn btn-sm btn-secondary"
                          onClick={handleDownload}
                        >
                          <i className="mdi mdi-file-export"></i>{" "}
                          {props.t("Export CSV")}
                        </Button>
                        {"   "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("printDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {isLoading && (
                    <div className="mb-3">
                      <Progress
                        animated
                        color="info"
                        value={progress}
                        style={{
                          height: "20px",
                          color: "Highlight",
                          fontWeight: "bold",
                        }}
                      >
                        {Math.round(progress)}% Loading...
                      </Progress>
                    </div>
                  )}
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Products)")}
                      <br />
                      <h6>
                        (cogs = opening cost + purchase cost + inbound transfer
                        cost - outbound transfer cost - closing cost)
                      </h6>
                    </CardTitle>

                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            noDataIndication={
                              isLoading ? (
                                <Spinner size={"md"} />
                              ) : (
                                "No data to display."
                              )
                            }
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(COGSProductsDateRangeReport)),
);
